import * as wConst from "../consts/website-consts";
import Cookies from "universal-cookie";
import * as adActs from "./advertise-actions";
import * as svrActs from "./server-actions";

import {addTask} from "domain-task";
import configureStore from "../configureStore";



export function getCookie(key) {
  const cookies = new Cookies();
  return cookies.get(key);
}

export function setCookie(key, value, options) {
  const cookies = new Cookies();
  cookies.set(key, value, options);
}

export function removeCookie(key) {
  const cookies = new Cookies();
  let domain = "." + getSubdomain(window.location.hostname);
  //console.log("Removing Cookie:" + key);
  cookies.remove(key, { path: "/", domain: domain });
}

export function needsProfiles(rtes, pth) {
  let isList = false;
  if (pth === "") pth = "/";
  rtes.map((v, i) => {
    if (v.path === "") { v.path = "/"; }
    if (v.path == pth) {
      let tmp = v.template.toLowerCase();
      if (tmp === "profileslist" || tmp === "home" || tmp === "search") {
        isList = true;
      }
    }
  });
  return isList;
}


export function showLogin() {
  return {
    type: wConst.ACTION_SHOW_LOGIN,
    payload: true
  };
}
export function hideLogin() {
  return {
    type: wConst.ACTION_HIDE_LOGIN,
    payload: true
  };
}

export function maskPhone(phn,last,char="*") {
  let iStr = '+0123456789 ';
  let iChr = Array.from(phn);
  last = iChr.length - last;
  let iRtn = "";
  //console.log(iChr);
  iChr.map((v,i)=>{
    if(iStr.indexOf(v) >= 0) {

      if(v===" ") {
        iRtn += v;
        last--;
      } else {
        if(i >= last) {
          iRtn += char;
        } else {
          iRtn += v;
        }
      }
    }
    return null;
  });
  return iRtn;
}

export function isAdult(web) {
  if(!isNullOrEmpty(web.Settings.Group) && web.Settings.Group == "Other") {
    return false;
  }
  if(!isNullOrEmpty(web.Settings.Domain) && web.Settings.Domain == "www.ads1k.com") {
    return false;
  }
  return true;
}

export function getTranslation(key,lst) {
  return lst.Translations[key];
}

export function loadMoreData(dispatch,pge,set,ref,ip,aid,cc) {
  let adPro = false;
  let smPro = false;
  let lPro = false;

  let term = getParameterByName("term", ref, "");
  if (!isNullOrUndefined(pge.Template)) {
    if (pge.Template.Name.toLowerCase() === "advertise") {
      //adPro = true;
    }
    if (pge.Template.Name.toLowerCase() === "sitemap") {
      smPro = true;
    }
    if (pge.Template.Name.toLowerCase() === "links") {
      lPro = true;
    }
  }

  if (lPro) {
    let links = new Promise((resolve) => {
      resolve(dispatch(GetLinkBanners(ref)));
    });
    addTask(links);
  }
  if (adPro) {
    let ads = new Promise((resolve) => {
      resolve(dispatch(adActs.GetAdDataNew(ref,ip)));
    });
    addTask(ads);
  }
  if(smPro) {
    let sitemap = new Promise((resolve)=>{
      resolve(dispatch(getSiteMap(ref)));
    });
    addTask(sitemap);
  }

  /*
  let pops = new Promise((resolve) => {
    resolve(dispatch(adActs.GetPopularPackages(ref)));
  });
  addTask(pops);
  */


  if(typeof window == "undefined") {
    let ssrCreatives = [ //Would Set This Is Settings Or HtmlTags
      {Key: "home-300x100", Count: "10", Min: "10", Max: "10", MaxBuyAds: "1", MinBuyAds: "1", Promise: null},
      {Key: "links-468x60", Count: "100", Min: "100", Max: "100", MaxBuyAds: "0", MinBuyAds: "0", Promise: null},
    ];
    ssrCreatives.map((v)=>{ //Add Talk For Each Call :)
      v.Promise = new Promise((resolve)=>{
        resolve(dispatch(getCreative(v.Key, v.Count, v.Min, v.MinBuyAds, v.MaxBuyAds, ref, aid, v.Max,ip,cc)));
      });
      addTask(v.Promise);
      return null;
    });
  }
}


function getCreative(key,count,min,minbuy,maxbuy,ref,aid,max,ip,cc) {
  return (dispatch,getState)=>{
    let logMe = false;
    if(getParameterByName("logSSR",ref,"") !== "") { logMe=true }
    dispatch({type: wConst.FETCH_SSRADS_PENDING, payload: key});
    let headers = {
      'X-Alt-Referer': ref,
      'X-Alt-AnonymousId': aid,
      'X-Alt-IP': ip,
      'X-Alt-Country': cc
    };
    let url = `${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/creatives/${key}?max=${count}&minAdvertiseHere=${minbuy}&maxAdvertiseHere=${maxbuy}&min=${min}&maxStandard=${max}`;
    if (logMe) {
      console.log(`Calling: ${url} With Referer: ${ref}`);
    }
    let task = fetch(url, {headers: headers})
      .then(resp => resp.json())
      .then((data) => {
        if(data.Code == 200) {
          dispatch({type: wConst.FETCH_SSRADS_FULLFILLED, payload: {Key: key, Value: data}});
          if(logMe) { console.log("SSRResp: " + JSON.stringify(data)); }
        } else {
          dispatch({type: wConst.FETCH_SSRADS_FULLFILLED, payload: {Key: key, Value: data}});
          if(logMe) { console.log("SSRBADResp: " + JSON.stringify(data)); }
        }
      })
      .catch((ex) => {
        dispatch({type: wConst.FETCH_SSRADS_FULLFILLED, payload: {Key: key, Value: {Code: 500, Message: "Internal Error:" + ex.toString() + ":" + ref}}});
        if(logMe) { console.log("SSRERRResp: " + ex.toString()); }
      });
    addTask(task);
  };
}




export function GetLinkBanners(ref) {
  return function(dispatch,getState) {
    dispatch({type: wConst.ACTION_LINKBANNERS_PENDING, payload: ""});
    if(!ref) ref = getReferer();
    let headers = {
      'X-Alt-Referer': ref,
      'Content-type': 'application/json',
    };

    let qStr = "";
    if (typeof document !== "undefined") {
      qStr = document.location.toString();
    } else {
      qStr = getState().Website.ServerParams.Query;
    }
    qStr = "http://www.fakeurl.com/" + qStr;
    let page = getParameterByName("page", qStr);
    if(isNullOrEmpty(page)) {page="1"}
    let auth = getBearer(getState().Website.ServerParams.Cookies);
    if(!isNullOrEmpty(auth)) { headers.Authorization = "Bearer " + auth; }
    let task = fetch(`${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/links/banners?filter=Both&pageSize=100&page=${page}`,{headers: headers, method: "GET"})
      .then(resp => resp.json())
      .then((data) => {
        if(data.Code === 200) {
          dispatch({type: wConst.ACTION_LINKBANNERS_SUCCESS, payload: data});
        } else {
          dispatch({type: wConst.ACTION_LINKBANNERS_FAILURE, payload: data});
        }
      })
      .catch((ex) => {
          dispatch({type: wConst.ACTION_LINKBANNERS_FAILURE, payload: {Code: 500, Message: "Internal Error..:" + ex.Message}});
        }
      );
    addTask(task);
  }
}



function getReferer() {
  if (typeof document === "undefined") {
    return "";
  }
  let referer = document.location.toString();
  if(referer.indexOf("localhost")>=0 || referer.indexOf("10.0.0.")>=0) {
    referer = "https://staging.topescort.nl" + document.location.pathname + (document.location.search.length > 1 ? document.location.search : "");
  }
  return referer;
}

export function GetReferer() {
  return getReferer();
}


export function culturePath(pth) {
  if(pth.length>=4) {
    let tt = pth.substr(3,1);
    if(tt === "/") {
      return pth.substr(1,2);
    }
  } else {
    if(pth.length === 3) {
      return pth.substr(1,2);
    }
  }
  return "/";
}

export function stripCulturePath(pth) {
  if(pth.length>=4) {
    let tt = pth.substr(3,1);
    if(tt === "/") {
      return "/" + pth.substr(4);
    }
  } else {
    if(pth.length === 3) {
      return "/" + pth.substr(3);
    }
  }
  return pth;
}

export function defaultLang(dta) {
  return dta.Settings.DefaultLanguageCode;
}

export function getLocationWithSearch(cc,pth,qry) {
  if(isNullOrUndefined(pth)) {pth=document.location.pathname}
  if(isNullOrUndefined(qry)) {qry=document.location.pathname}
  if(cc.length === 1) {
    return stripCulturePath(pth) + (qry.length >= 2 ? qry : "");
  } else {
    return "/" +cc.toLowerCase() + (pth === "" ? "/" : stripCulturePath(pth)) + (qry.length >= 2 ? qry : "");
  }
}

export function isNullOrUndefined(val) {
  return val === null || typeof val === "undefined";
}

export function getCultByLang(dta,lang) {
  let cult;
  dta.Settings.Languages.map((v,y) => {
    if(v.Code.toLowerCase() === lang.toLowerCase()) {
      cult = v;
    }
    return null;
  });
  return cult;
}

export function getCultByPath(dta,path) {
  let cult = null;
  if(path === "/") {
    let lang = defaultLang(dta);
    return getCultByLang(dta,lang);
  }
  dta.Settings.Languages.map((v,y) => {
    if(isNullOrUndefined(v.Path)) { return null; }
    if(v.Path.toLowerCase() === path.toLowerCase()) {
      cult = v;
    }
    return null;
  });
  return cult;
}



export function getCultPath(dta,path) {
  let cult = path;
  //console.log(dta.Settings.Languages);
  dta.Settings.Languages.map((v, y) => {
    if (v.Selected) {
      if (dta.Settings.SmartDefaultLanguage && v.Default) {
        cult = path;
      } else {
        cult = "/" + v.Path + path;
      }
    }
    return null;
  });
  return cult;
}
export function getCultPathByLang(dta,lang) {
  let cult;
  dta.Settings.Languages.map((v) => {
    if(isNullOrUndefined(v.Code)) { return null; }
    if(v.Code.toLowerCase() === lang.toLowerCase()) {
      if(v.Default && dta.Settings.SmartDefaultLanguage) {
        cult = "/";
      } else {
        cult = "/" + v.Path + "/";
      }
    }
    return null;
  });
  return cult;
}

export function markLanguageSelected(dta,srch) {
  dta.Settings.Languages.map((v,i)=>{
        if(isNullOrUndefined(v.Path)) { return null; }
        if(v.Path.toLowerCase() === srch.toLowerCase()) {
          v.Selected = true;
        } else {
          if(v.Code.toLowerCase() === srch.toLowerCase()) {
            v.Selected = true;
          } else {
            v.Selected = false;
          }
        }

    return null;
  });
  return dta;
}

export const lsKey = 'siteways-lang';

export function checkCulture(dta) {
  let cp = culturePath(document.location.pathname);
  let che = localStorage.getItem(lsKey);
  if(che === null) { che = cp; }
  let lanPath = ""
  let smtLan = dta.Settings.SmartDefaultLanguage;
  dta.Settings.Languages.map((v,i) => {
    if(v.Code === defaultLang(dta)) {
      v.Default = true;
      v.Selected = true;
      if(!smtLan) {
        lanPath =  v.Path;
      }
    } else {
      v.Default = false;
      v.Selected = false;
    }
    if(v.Path === null) {
      v.Path = "xx";
    }
    return null;
  });
  dta.Settings.SelectedLocal = smtLan ? "/" : lanPath;
  dta.Settings.SelectedLang = defaultLang(dta);


  if(cp === "/" && !smtLan) {
    localStorage.setItem('siteways-lang',lanPath);
    let loc = getLocationWithSearch(lanPath)
    document.location = loc;
    return dta;
  }

  //Fix People Who Cached The "/"
  if(che === "/" && lanPath !== cp && !smtLan) {
    localStorage.setItem('siteways-lang',lanPath);
    let loc = getLocationWithSearch(lanPath)
    document.location = loc;
    return dta;
  }


  //OVERIDE NO MATTER WHAT CULTURE IS :)
  if(cp !== che && (che !=="/" && !dta.Settings.SmartDefaultLanguage && cp === lanPath )) {
    let loc = getLocationWithSearch(che); //getCultPath(dta,che); //getLocationWithSearch(che);
    dta.Settings.SelectedLocal = che;
    dta.Settings.SelectedLang = getCultByPath(dta,che).Code;
    if(che !== "/") { dta = markLanguageSelected(dta,che); }
    document.location = loc;
    return dta;
  }

  //if(cult !== cp && che !== cp) {
  //  let loc = getCultPath(dta,cult);
  //  document.location = loc;
  //}


  //OVERIDE TO AUTO Path, Use Sites Default If Nothing Set :)
  if(cp !== "/") { //Set Culture On Path?
      let c = getCultByPath(dta,cp);
      if(c !== null) { //Setup The Right Dealies Then :)
        dta.Settings.SelectedLocal = cp;
        dta.Settings.SelectedLang = getCultByPath(dta,cp).Code
        if(cp !== "/") { dta = markLanguageSelected(dta,cp); }
        return dta;
      }
  }

  //console.log(`Check Culture: ${che} : ${cp} `);
  return dta;
}

export function getRoute(dta,pth) {
  let pge = dta.Routes.filter((t) => { return t.Path.toLowerCase() === pth.toLowerCase() })[0];
  if(typeof pge === "undefined") {
    pge = null;
  }
  return pge;
}
/*
function checkBlocks() {

}
*/
export function saveSitePaths(dta) {
  var paths = [];
  Object.keys(dta.Menu).map((v) => {
    let vm = dta.Menu[v];
    vm.map((val) => {
      if (!isNullOrUndefined(val.Page)) {
        if (paths.filter((t) => t.Path === val.Page.Path).length === 0) {
          if (val.Page.Path !== "" && typeof val.Page.Path !== "undefined") {
            paths.push({ path: val.Page.Path, settings: val.Settings });
          }
        }
      }
      if(typeof val.Menu !== "undefined" && val.Menu.length > 0) {
        val.Menu.map((sval) => {
          if (!isNullOrUndefined(sval.Page)) {
            if (sval.Page.Path !== "" && typeof sval.Page.Path !== "undefined") {
              paths.push({ path: sval.Page.Path, settings: sval.Settings });
            }
          }
          return null;
        });
      }
      return null;
    });
    return null;
  });





  var profilePath = "";
  dta.Routes.map((v) => {
    if(v.Template === "Profile") {
      profilePath = stripCulturePath(v.Path);
      v.Path = v.Path.replace("{{Name}}",":name").replace("{{Id}}",":id");
      //console.log(profilePath);
    }
    return null;
  });

  if(profilePath !== "") {
    paths.push({path: profilePath.replace("{{Name}}",":name").replace("{{Id}}",":id")});
    dta.ProfilePath = profilePath.replace("/{{Name}}-{{Id}}","");
  } else {
    paths.push({path: "/:name-:id", Settings: undefined});
    dta.ProfilePath = "";
  }


  dta.Paths = paths;

  return dta;
}
export function doTranlationReplaces(dta) {

  //Footer Jazz
  let tStr = dta.Translations["page.footer.copyright"];
  if(!isNullOrUndefined(tStr)) {
    tStr = tStr.replace("{{Year}}", new Date().getFullYear());
    tStr = tStr.replace("{{SiteName}}", dta.Settings.SiteName);
    dta.Translations["page.footer.copyright"] = tStr;
  }
  tStr = dta.Translations["page.footer.version"];
  if(!isNullOrUndefined(tStr)) {
    tStr = tStr.replace("{{Version}}", wConst.APP_VERSION);
    tStr = tStr.replace("{{Ip}}", dta.Request.IpAddress);
    tStr = tStr.replace("{{CountryCode}}", dta.Request.CountryCode);
    dta.Translations["page.footer.version"] = tStr;
  }

  tStr = dta.Translations["page.footer.codeofconduct"];
  if(!isNullOrUndefined(tStr)) {
    tStr = tStr.replace("{{Year}}", new Date().getFullYear());
    tStr = tStr.replace("{{SiteName}}", dta.Settings.SiteName);
    dta.Translations["page.footer.codeofconduct"] = tStr;
  }
  tStr = dta.Translations["page.warning"];
  if(!isNullOrUndefined(tStr)) {
    tStr = tStr.replace("{{Year}}", new Date().getFullYear());
    tStr = replaceAll("{{SiteName}}", dta.Settings.SiteName, tStr)
    dta.Translations["page.warning"] = tStr;
  }

  tStr = dta.Translations["page.footer.thebiggestnetworkintheworld"];
  if(!isNullOrUndefined(tStr)) {
    tStr = replaceAll("{{SiteName}}", dta.Settings.SiteName, tStr)
    dta.Translations["page.footer.thebiggestnetworkintheworld"] = tStr;
  }

  let sUrl = "";
  dta.Routes.map((v) => {
    if(v.template === "Support") {
      sUrl = v.path;
    }
  });


  tStr = dta.Translations["page.signup.thankyouforyourregistrationtext"];
  if(!isNullOrUndefined(tStr)) {
    tStr = tStr.replace("{{WebsiteName}}", dta.Settings.SiteName);
    tStr = tStr.replace("{{SupportUrl}}", sUrl);
    dta.Translations["page.signup.thankyouforyourregistrationtext"] = tStr;
  }

  tStr = dta.Translations["page.confirm.main"];
  if(!isNullOrUndefined(tStr)) {
    tStr = tStr.replace("{{WebsiteName}}", dta.Settings.SiteName);
    tStr = tStr.replace("{{SupportUrl}}", sUrl);
    dta.Translations["page.confirm.main"] = tStr;
  }
  //page.links.areyouinterestedinabannerorlinkexchangewithus

  tStr = dta.Translations["page.links.areyouinterestedinabannerorlinkexchangewithus"];
  if(!isNullOrUndefined(tStr)) {
    tStr = tStr.replace("{{SeoName}}", dta.Settings.SeoName);
    tStr = tStr.replace("{{SupportUrl}}", sUrl);
    dta.Translations["page.links.areyouinterestedinabannerorlinkexchangewithus"] = tStr;
  }



  return dta;
}

export function showWarning(lvl,msg) {
  return (dispatch) => {
    dispatch({type: wConst.SHOW_WARNING, payload: {Message: msg, Type: lvl, Showing: true}});
  }
}


export function replaceAll(rW,wW,rep) {
  let tStr = rep;
  while(tStr.indexOf(rW)>=0) {
    tStr = tStr.replace(rW, wW)
  }
  return tStr;
}

export function loadWebsiteSettings() {
  return function (dispatch,getState) {


    dispatch({ type: wConst.ACTION_FETCH_WEBSITESETTINGS_PENDING, payload: true });
    let ref = getReferer();

    let headers = {
      'X-Alt-Referer': ref,
    };

    let auth = localStorage.getItem("siteways-bearer");
    if (!isNullOrEmpty(auth)) {
      let authD = JSON.parse(auth);
      headers["Authorization"] = "Bearer " + authD.access_token;
    }

    fetch(`${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/context?include=page%2Csettings%2Chtmlsections%2Cmenu`, { headers: headers })
      .then(resp => resp.json())
      .then(function (data) {
        if (!data.Result) {
          //console.log("Could not load settings for site", data);
          return;
        }
        let routeRef = getReferer();



        fetch(`${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/context/pages`, { headers: { 'X-Alt-Referer': routeRef } })
          .then(resp => resp.json())
          .then(function (rtes) {
            data.Result.Routes = rtes.Result; //These Are Pages To Route


            //Put Alot Of Site Stuff To Do When Loaded :) BEFORE We Fill The Dam Screen :P
            data.Result = checkCulture(data.Result);
            data.Result = saveSitePaths(data.Result);



            let tLoc = data.Result.Settings.SelectedLocal;
            //console.log(tLoc);
            if (data.Result.Settings.SelectedLocal === "/") {
              tLoc = getCultByLang(data.Result, defaultLang(data.Result)).Path;
            }
            let fLoc = tLoc;
            if (fLoc.toLowerCase() === "xx") {
              fLoc = "en"; //Load The English Local DB, And Then Load xx Which Has No Keys :)
            }
            //console.log(tLoc);

            fetch(`/locals/${tLoc}.json`)
              .then(resp => resp.json())
              .then(function (strs) {
                data.Result.Translations = strs;
                data.Result.TranslationsLocal = fLoc === "gr" ? "el" : fLoc;
                doTranlationReplaces(data.Result);
                dispatch({ type: wConst.ACTION_FETCH_WEBSITESETTINGS_FULLFILLED, payload: data.Result });
              });



          });
      });
    //.catch(function(ex, ex1) {
    //    console.log(ex);
    // }
    //);
  };
}

export function cmtoFeet(cm) {
  let tcm = parseInt(cm,10);
  let feet = tcm * .032804;
  return parseFloat(feet).toPrecision(2);
}

export function kgtoPounds(kg) {
  let tkg = parseInt(kg,10);
  let pounds = tkg * 2.20462;
  return Math.round(pounds);
}


export function clearLoginError() {
  return (dispatch) => {
    dispatch({type: wConst.ACTION_LOGIN_CLEARERROR, payload: ""});
  };
}

export function getProfilePath(dta,newpath) {
  let loc = window.location.pathname;
  if(loc.indexOf("/") === 0 && loc.indexOf("/",1) === 3) {
    let lang = loc.split("/")[1];
    return `/${lang}${dta.ProfilePath}${newpath}`;
  } else {
    return `${dta.ProfilePath}${newpath}`;
  }
}

export function getPath(newpath) {
  let loc = window.location.pathname;
  if(loc.indexOf("/") === 0 && loc.indexOf("/",1) === 3) {
    let lang = loc.split("/")[1];
    return `/${lang} ${newpath}`;
  }
  return newpath;
}

export function getParameterByName(name, url, def) {
  if(typeof def === "undefined") { def = null;}
  if (typeof window === "undefined" && !url) { return def; }
  if (!url) url = window.location.href;
  name = name.replace(/[[]]/g, '\\$&');
  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return def;
  if (!results[2]) return def;
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


export function SubDomain(wp) {
  if(typeof window === "undefined") {
    if(!isNullOrUndefined(wp.ServerParams)) {
      try {
        let host = new URL(wp.ServerParams.Referer);
        return getSubdomain(host.hostname);
      } catch(ex) {
      }
    }
  } else {
    let host = new URL(window.location.href);
    return getSubdomain(host.hostname)}
  return "";
}

export function getSubdomain(hostname) {
  let prts = hostname.split(".");
  while (prts.length > 2) {
    prts.shift();
  }
  return prts.join(".");
}

export function loginNow(props) {
  return (dispatch,getState) => {
    dispatch({ type: wConst.ACTION_FETCH_LOGIN_PENDING, payload: true });
    let bdy = "grant_type=password&username=" + encodeURIComponent(props.Username) + "&password=" + encodeURIComponent(props.Password) + "&client_id=escort&client_secret=simplesecret";

    fetch(`${wConst.TOKEN_URL}`, {
      headers: {
        'X-Alt-Referer': window.location.toString(),
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'POST',
      body: bdy
    })
      .then(resp => resp.json())
      .then(function (data) {
        //console.log("data", data);
        if (data.error) {
          dispatch({ type: wConst.ACTION_FETCH_LOGIN_REJECTED, payload: "" });
          dispatch(showWarning("WARN", props.FailText));
        } else {
          dispatch(showWarning("INFO", props.SuccessText));
          let domain = "." + getSubdomain(window.location.hostname);
          dispatch({ type: wConst.ACTION_FETCH_LOGIN_FULFILLED, payload: "" });
          localStorage.setItem("siteways-bearer", JSON.stringify(data)); //Setup Bearer For Context Call :)
          setCookie("auth", data.access_token, { path: "/", maxAge: 31557600, domain: domain });
          let ste = getState();
          if(!isNullOrEmpty(ste.Website.OnLoginUrl)) {
            window.location = ste.Website.OnLoginUrl;
          } else {
            window.location = getCultPath(getState().Website,"/");
          }
        }
      })
      .catch(function (ex) {
        console.log("Error", ex);
        dispatch({ type: wConst.ACTION_FETCH_LOGIN_REJECTED, payload: "" });
        dispatch(showWarning("WARN", props.FailText));
      });
  };
}


export function getSiteMap(ref) {
  return (dispatch,getState) => {
    dispatch({ type: wConst.FETCH_SITEMAP_PENDING, payload: true });
    let sMap = fetch(`${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/sitemap`, {
      headers: {
        'X-Alt-Referer': ref
      },
    })
      .then(resp => resp.json())
      .then(function (data) {
        //console.log("data", data);
        if (data.Code !== 200) {
          dispatch({ type: wConst.FETCH_SITEMAP_REJECTED, payload: data });
        } else {
          dispatch({ type: wConst.FETCH_SITEMAP_FULLFILLED, payload: data });
        }
      })
      .catch(function (ex) {
        console.log("Error", ex);
        dispatch({ type: wConst.FETCH_SITEMAP_REJECTED, payload: {Code: 500, Message: "Internal Error: " + ex.toString()}});
      });
    addTask(sMap);
  };
}




export function isNullOrEmpty(obj) {
  if(typeof obj === "undefined") { return true;}
  if(obj === null) { return true;}
  if(typeof obj === "string") { return obj === "" }
  return false;
}

export function SendGooglePage(gaId,params) {
  try {
    window.ga('send','pageview',params.page_path);
  } catch(ex) {
  }
}
export function SendGoogleEvent(gaId,cat,act,lbl) {
  try {
    window.ga('send','event',cat,act,lbl);
    console.log('Sent Google',{Cat: cat, Act: act, Lbl: lbl});
  } catch(ex) {
  }
}



export function rewriteLinkHeaders(pdta,query,dpth) {

  //console.log(dpth);
  dpth = isNullOrUndefined(dpth) ? "" : dpth.Path;
  let url = "";
  if(typeof window !== "undefined") {
    url = window.location.href;
  } else {
    url = "https://www.fake.com" + query;
  }

  let pge = getParameterByName("page", url, "");
  let trm = getParameterByName("term", url, "");
  let lnk = getParameterByName("linktype", url, "");
  if(!isNullOrEmpty(pge) || !isNullOrEmpty(trm) || !isNullOrEmpty(lnk)) {
    let qry = "?";
    if (!isNullOrEmpty(pge)) { qry = "?page=" + pge; }
    if (!isNullOrEmpty(trm)) { qry += qry.endsWith("?") ? "term=" + trm : "&term=" + trm; }
    if (!isNullOrEmpty(lnk)) { qry += qry.endsWith("?") ? "linktype=" + lnk : "&linktype=" + lnk; }
    if(!isNullOrUndefined(pdta.References)) {
      pdta.References.filter((t) => { return t.Rel.toLowerCase() === "alternate" || t.Rel.toLowerCase() === "canonical"; }).map((v) => {

        v.Href = v.Href.split("?")[0];
        if (v.Href.endsWith("/") && v.Href !== "/") {
          v.Href = v.Href.substr(0, v.Href.length - 1);
        }
        v.Href = v.Href + qry;


      });
    }
    if (!isNullOrUndefined(pdta.Properties)) {
      let ogProp = pdta.Properties.filter((t) => { return t.Name.startsWith("og:url"); });
      if (ogProp.length > 0) {
        ogProp[0].Content = ogProp[0].Content.split("?")[0];
        if (ogProp[0].Content.endsWith("/") && ogProp[0].Content !== "/") {
          ogProp[0].Content = ogProp[0].Content.substr(0, ogProp[0].Content.length - 1);
        }
        ogProp[0].Content = ogProp[0].Content + qry;
      }
    }
  } else {
    if(!isNullOrUndefined(pdta.References)) {
      pdta.References.filter((t) => { return t.Rel.toLowerCase() === "alternate" || t.Rel.toLowerCase() === "canonical"; }).map((v) => {
        v.Href = v.Href.split("?")[0];
        if (v.Href.endsWith("/") && v.Href !== "/") {
          v.Href = v.Href.substr(0, v.Href.length - 1);
        }
      });
    }
  }
  return pdta;
}


export function loadPage() {
  return function (dispatch, getState) {
    dispatch({ type: wConst.ACTION_FETCH_PAGE_PENDING, payload: false });
    let tState = getState();
    let gaId = tState.Website.Settings.GoogleAnalyticsId;
    let path = document.location.pathname.toLowerCase();
    let term = getParameterByName("term",window.location.href,"");
    //console.log("path",path);
    path = path + term !== "" ? "?term=" + term : "";
    if (path in tState.Website.Pages) { //Already Have This Page Cached Do Not Call Page API Again :)
      //Update The Alternates A Canonicals To Include To page= If Exsists

      tState.Website.Pages[path] = rewriteLinkHeaders(tState.Website.Pages[path], "", getCultByLang(tState.Website,defaultLang(tState.Website)));

      dispatch({ type: wConst.ACTION_FETCH_PAGE_FULLFILLED, payload: tState.Website.Pages[path] });
      SendGooglePage(gaId,{'page_path': tState.Website.Pages[path].Path});
      loadMoreData(dispatch,tState.Website.Pages[path],tState.Website.Settings,window.location.href,tState.Website.ServerParams.Ip,tState.Website.Request.AnonymousId,tState.Website.Request.CountryCode);
      return;
    }
    let ref = getReferer();
    let headers = {
      'X-Alt-Referer': ref,
      'X-Alt-AnonymousId': tState.Website.Request.AnonymousId
    };
    fetch(`${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/context/page`, { headers: headers })
      .then(resp => resp.json())
      .then(function (data) {
        if (!data.Result) {
          console.log("Could not load page settings for site", data);
          return;
        }

        data.Result = rewriteLinkHeaders(data.Result, "", getCultByLang(tState.Website,defaultLang(tState.Website)));


        dispatch({ type: wConst.ACTION_FETCH_PAGE_FULLFILLED, payload: data.Result });
        SendGooglePage(gaId,{'page_title': data.Result.Title, 'page_path': data.Result.Path});

        loadMoreData(dispatch,data.Result,tState.Website.Settings,window.location.href,tState.Website.ServerParams.Ip,tState.Website.Request.AnonymousId,tState.Website.Request.CountryCode);

        if(!isNullOrEmpty(data.Result.PriceList)) {
          dispatch({ type: wConst.FETCH_PRICELIST_FULLFILLED, payload: { Code: 200, Message: "", Result: data.Result.PriceList } });
        }


        if(data.Result.Name !== "404") {
          dispatch(SendPageVisit(getReferer(),"",tState.Website.Request.AnonymousId,tState.Website.Request.CountryCode,""));
        }

      })
      .catch(function (ex, ex1) {
        console.log(ex);
      }
      );
  };
}

export function uploadImage(dta,cb) {
  if(dta.FileName !== "") {

    let ref = getReferer();

    let headers = {
      'X-Alt-Referer': ref,
    };

    const data = new FormData();
    data.append('file',dta.File);
    data.append('filename',dta.FileName);

    let auth = localStorage.getItem("siteways-bearer");
    if(!isNullOrEmpty(auth)) {
      let authD = JSON.parse(auth);
      headers["Authorization"] = "Bearer " + authD.access_token;
    }

    fetch(`${wConst.ROOT_URL()}/support/attachments/${dta.Guid}`,{headers: headers, method: "POST", body: data})
      .then(resp => resp.json())
      .then(function(data) {
        cb();
      })
      .catch(function(ex, ex1) {
          console.log(ex);
          cb();
        }
      );
  } else {
    cb();
  }
}



export function Signup(dta,his,gto) {
  return (dispatch, getState) => {
    dispatch({ type: wConst.SIGNUP_STATUS_PENDING, payload: wConst.SIGNUP_STATUS_PENDING });
    let ref = getReferer();
    let headers = {
      'X-Alt-Referer': ref,
      'Content-type': 'application/json'
    };

    //dispatch({ type: wConst.SIGNUP_STATUS_SUCCESS, payload: "Testing signup movment", EmailAddress: "Someemail@gmail.com" });
    //his.push(gto);
    //return;

    fetch(`${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/signup`, { headers: headers, method: "POST", body: JSON.stringify(dta) })
      .then(resp => resp.json())
      .then(function (data) {
        if (data.Code !== 200) {
          dispatch({ type: wConst.SIGNUP_STATUS_FAILED, payload: data.Message });
        } else {
          dispatch({ type: wConst.SIGNUP_STATUS_SUCCESS, payload: data.Message, EmailAddress: dta.EmailAddress });
          his.push(gto);
        }
      }).catch(function (ex) {
        console.log(ex);
        dispatch({ type: wConst.SIGNUP_STATUS_FAILED, payload: "Internal error posting signup" });
      });
  };
}





export function SendSupportMessage(dta) {
  return (dispatch,getState) => {
    dispatch({type: wConst.ACTION_SUPPORT_SENDMESSAGE_PENDING, payload: wConst.SUPPORT_STATUS_PENDING});
    let ref = getReferer();
    let tState = getState();
    let bdy = tState.Website.Support.Response;
    bdy.Name = dta.Name; bdy.Text = dta.Message; bdy.EmailAddress = dta.Email;
    let tBdy = JSON.stringify(bdy);
    let headers = {
      'X-Alt-Referer': ref,
      'Content-type': 'application/json'
    }
    let auth = localStorage.getItem("siteways-bearer");
    if(!isNullOrEmpty(auth)) {
      let authD = JSON.parse(auth);
      headers["Authorization"] = "Bearer " + authD.access_token;
    }

    dta.Guid = bdy.Guid;
    uploadImage(dta,() => {
      fetch(`${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/support/tickets`,{headers: headers, method: "POST", body: tBdy})
        .then(resp => resp.json())
        .then(function(data) {
          if(data.Code !== 200) {
            dispatch({type: wConst.ACTION_SUPPORT_SENDMESSAGE_FAILED, payload: data.Message});
            return;
          }

          //console.log("Support Data: ", data);

          dispatch({type: wConst.ACTION_SUPPORT_SENDMESSAGE_FULFILLED, payload: data.Message});

        })
        .catch(function(ex, ex1) {
            console.log(ex);
            dispatch({type: wConst.ACTION_SUPPORT_SENDMESSAGE_FAILED, payload: ex.toString()});
          }
        );
    });



    //setTimeout(() => {dispatch({type: wConst.ACTION_SUPPORT_SENDMESSAGE_FAILED, payload: "Your message was not sent"})},3000);
    //setTimeout(() => {dispatch({type: wConst.ACTION_SUPPORT_SENDMESSAGE_FULFILLED, payload: "Your message was sent"})},3000);
  }
}
export function GetSupportId() {
  return function(dispatch,getState) {
    dispatch({type: wConst.ACTION_SUPPORT_GET_PENDING, payload: ""});
    let ref = getReferer();

    let headers = {
      'X-Alt-Referer': ref,
    }

    let auth = localStorage.getItem("siteways-bearer");
    if(!isNullOrEmpty(auth)) {
      let authD = JSON.parse(auth);
      headers["Authorization"] = "Bearer " + authD.access_token;
    }


    fetch(`${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/support/tickets`,{headers: headers})
      .then(resp => resp.json())
      .then(function(data) {
        if(!data.Result) {
          console.log("Could not load support GUID",data);
          return;
        }

        dispatch({type: wConst.ACTION_SUPPORT_GET_FULFILLED, payload: data.Result});

      })
      .catch(function(ex, ex1) {
          console.log(ex);
          dispatch({type: wConst.ACTION_SUPPORT_GET_FAILED, payload: ex.toString()});
        }
      );
  }
}


export function getBearer(cks) {
  let authC = getCookie("auth");
  if(!isNullOrEmpty(authC)) {
    return authC;
  }
  authC = svrActs.getServerCookie(cks,"auth");
  if(!isNullOrEmpty(authC)) {
    return authC;
  }
  return "";
}


export function SendPageVisit(loc,ip,aid,cc,ua,cks) {
  return (dispatch,getState) => {
    if(ua.toLowerCase().indexOf("zabbix")>-1) {
      //console.log("Ignored Zabbix PageHit: " + ip + ":" + aid);
      return;
    }
    let ref = isNullOrEmpty(loc) ? getReferer() : loc;
    let bear = getBearer(cks);
    let headers = {
      'X-Alt-Referer': ref,
      'Content-type': 'application/json',
      'X-Alt-AnonymousId': aid,
      'X-Alt-Country': cc
    };
    if(!isNullOrEmpty(ip)) {
      headers['X-Alt-IP'] = ip;  //'X-Alt-IP': ip,
    }
    if(!isNullOrEmpty(ua)) {
      headers['X-Alt-UserAgent'] = ua;  //'X-Alt-IP': ip,
    }
    if(!isNullOrEmpty(bear)) {
      headers.Authorization = "Bearer " + bear;
    }
    console.log("PageVisit Headers: " + JSON.stringify(headers));

    fetch(`${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/context/page/visit`,{headers: headers, method: "POST", body: JSON.stringify({})})
      .then(resp => resp.json())
      .then((data) => {
        if(data.Code === 200) {
          //console.log("Register'd Page View: " + data.Message);
        } else {
          console.log("Got code " + data.Code + " registering page view: " + data.Message);
        }
      }).catch((ex) => {
        console.log("Got error registering page view",ex);
      });
  }
}


export function SendConfirmation(dta,his,gto) {
  return function(dispatch,getState) {
    dispatch({type: wConst.CONFIRM_STATUS_PENDING, payload: ""});
    let ref = getReferer();
    let headers = {
      'X-Alt-Referer': ref,
      'Content-type': 'application/json'
    };

    let bdy = dta;

    fetch(`${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/signup/confirm`,{headers: headers, method: "POST", body: JSON.stringify(bdy)})
      .then(resp => resp.json())
      .then((data) => {
        if(data.Code === 200) {
          dispatch({type: wConst.CONFIRM_STATUS_SUCCESS, payload: data.Message});
          his.push(gto);
        } else {
          dispatch({type: wConst.CONFIRM_STATUS_FAILED, payload: data.Message});
        }
      })
      .catch((ex) => {
        dispatch({type: wConst.CONFIRM_STATUS_FAILED, payload: ex.toString()});
      }
    );
  };
}


export const customStyles = {
  option: (provided, state) => ({
    ...provided,
    borderRadius: "5px",
    border: '1px solid lightgray',
    boxShadow: null,
  }),
  menu: (provided, state) => ({
    ...provided,
    zIndex: "100"
  }),

  control: (provided, state) => ({
    ...provided,
    borderRadius: "5px",
    boxShadow: null,
    borderTopColor: "border-bottom-color: rgb(204, 204, 204)",
    borderLeftColor: "border-bottom-color: rgb(204, 204, 204)",
    borderRightColor: "border-bottom-color: rgb(204, 204, 204)",
    borderBottomColor: "border-bottom-color: rgb(204, 204, 204)",
    outline: null, maxHeight: "38px"
  }),
  placeholder: (provided,state) => ({
    ...provided,
    fontSize: ".9em",
    fontWeight: "400",
    outline: "none"
  }),
  valueContainer: (provided,state) => ({
    ...provided,
    border: "none"
  }),
  multiValueLabel: (provided,state) => ({
    ...provided,
    borderTopLeftRadius: "5px",
    borderBottomLeftRadius: "5px",
    outline: "none"
  }),
  multiValueRemove: (provided,state) => {
    return ({
      ...provided,
      borderTopRightRadius: "5px",
      borderBottomRightRadius: "5px",
      outline: "none",
    });
  },
};

export const editstyles = {
  editor: {
    border: '1px solid gray',
    minHeight: '6em'
  }
};
export const txtStyle = {height: "38px", fontWeight: "500", fontSize: "1.0em", color: "#222", paddingLeft: "9px"};


export function SendResetPassword(email) {
  return function(dispatch,getState) {
    dispatch({type: wConst.RESET_STATUS_PENDING, payload: email});
    let ref = getReferer();
    let headers = {
      'X-Alt-Referer': ref,
    };

    fetch(encodeURI(`${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/login/reset?id=${email}`),{headers: headers, method: "POST",})
      .then(resp => resp.json())
      .then((data) => {
        if(data.Code === 200) {
          dispatch({type: wConst.RESET_STATUS_SUCCESS, payload: data.Message});
          dispatch(showWarning("INFO",data.Message));
        } else {
          dispatch({type: wConst.RESET_STATUS_FAILED, payload: ""});
          dispatch(showWarning("ERROR",data.Message));
        }
      })
      .catch((ex) => {
          dispatch({type: wConst.RESET_STATUS_FAILED, payload: ""});
          dispatch(showWarning("ERROR","Internal Error sending message: " + ex.toString()));
        }
      );

  }
}

export function SendResetPasswordConfirmation(id,cde) {
  return function(dispatch,getState) {
    dispatch({type: wConst.RESET_CONFIRM_STATUS_PENDING, payload: {Id: id, ConfirmId: id, Code: cde }});
    let ref = getReferer();
    let headers = {
      'X-Alt-Referer': ref,
      'Content-type': 'application/json'
    };

    let bdy = {
      Id: id, Code: cde, Source: "escortnews"
    }

    fetch(encodeURI(`${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/login/reset/confirm`),{headers: headers, body: JSON.stringify(bdy), method: "POST",})
      .then(resp => resp.json())
      .then((data) => {
        if(data.Code === 200) {
          dispatch({type: wConst.RESET_CONFIRM_STATUS_SUCCESS, payload: data.Message});
          dispatch(showWarning("INFO",data.Message));
        } else {
          dispatch({type: wConst.RESET_CONFIRM_STATUS_FAILED, payload: ""});
          dispatch(showWarning("ERROR",data.Message));
        }
      })
      .catch((ex) => {
          dispatch({type: wConst.RESET_CONFIRM_STATUS_FAILED, payload: ""});
          dispatch(showWarning("ERROR","Internal Error sending message: " + ex.toString()));
        }
      );

  }
}




export function arrChunks(arr, size) {
  if (!Array.isArray(arr)) {
    return [];
  }

  if (typeof size !== 'number') {
    return [];
  }

  let result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, size + i));
  }

  return result;
}


export function chunkify(a, n, balanced) {

  if (n < 2)
    return [a];

  let len = a.length,
    out = [],
    i = 0,
    size;

  if (len % n === 0) {
    size = Math.floor(len / n);
    while (i < len) {
      out.push(a.slice(i, i += size));
    }
  }

  else if (balanced) {
    while (i < len) {
      size = Math.ceil((len - i) / n--);
      out.push(a.slice(i, i += size));
    }
  }

  else {

    n--;
    size = Math.floor(len / n);
    if (len % size === 0)
      size--;
    while (i < size * n) {
      out.push(a.slice(i, i += size));
    }
    out.push(a.slice(size * n));

  }

  return out;
}


export function isLoggedIn(web) {
  if(!isNullOrUndefined(web.User)) {
    if(web.User.UserId>0) {
      return true;
    }
  }
  return false;
}


//TEST Values For Testing :)
//export const ShowLeftBanners = false;
//export const ShowLeftMenu = true;
//export const ShowRightBanners = false;

export function MainLeftStyle(WebPage) {
  let {ShowLeftBanners, ShowLeftMenu, ShowRightBanners} = WebPage.Settings; //Get From Settings, Production
  let ShowLeft = (ShowLeftBanners || ShowLeftMenu);
   if(ShowLeft && ShowRightBanners) {
     return "";
   } else if(ShowLeft) {
     return "-noright";
   } else if(ShowRightBanners) {
     return "-noleft";
   } else {
     return "-nosides";
   }
}
